import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'

import { CsatWorkerEntity } from './types'
import csatWorkersTypes from './action-types'

export default generateEntityCrudReducer<CsatWorkerEntity>({
  name: 'csatWorkers',
  actions: csatWorkersTypes,
})
